export default "__VITE_ASSET__nHc19q2U__"